import React from "react";
import { useTimeZone } from "../../../../../../contexts/TimeZoneContext";

function getAirportCode(row, columnKey) {
    if (columnKey === "departureAirport") {
        return row.departureAirport || row.rawFlight?.departure_airport;
    }
    return row.arrivalAirport || row.rawFlight?.arrival_airport;
}

function getAirportName(airport) {
    return airport?.name_zh || airport?.chinese_name || airport?.name || airport?.airport_name || "";
}

const AirportCellRenderer = ({ row, column }) => {
    const { airportsMap } = useTimeZone();
    const code = getAirportCode(row, column.key);
    const airport = code ? airportsMap?.[code] : null;
    const name = getAirportName(airport);

    if (!code) {
        return <span className="schedule-draft-rdg-airport-empty">--</span>;
    }

    return (
        <span className="schedule-draft-rdg-airport-cell" title={name || code}>
            <span className="schedule-draft-rdg-airport-code">{code}</span>
        </span>
    );
};

export default AirportCellRenderer;
